/**
 * Voice loudness, 0..1. Not in Redux on purpose: it changes every frame, so consumers are animation loops
 * that read it rather than subscribe.
 */

const MIN_LEVEL = 0;
const MAX_LEVEL = 1;

let level = MIN_LEVEL;

const clampLevel = (value) => Math.min(Math.max(value, MIN_LEVEL), MAX_LEVEL);

const setLevel = (value) => {
    level = Number.isFinite(value) ? clampLevel(value) : MIN_LEVEL;
};

const getLevel = () => level;

// Silence, so a stopped source doesn't freeze an animation mid-word
const reset = () => setLevel(MIN_LEVEL);

export default {setLevel, getLevel, reset, clampLevel};
